import React, { useState } from 'react'
import { Breadcrumb, Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Card from '../../../UI/Card/Card'
import ConfirmationModal from '../../../UI/ConfirmationModal/ConfirmationModal'
import Graybg from '../../../UI/Graybg'
import SecBTN from '../../../UI/SecBTN'
import SuccessModal from '../../../UI/SuccessModal/SuccessModal'
import classes from './Unanswered.module.css'

const Unanswered = () => {
  const [showPopUp1,setShowPopUp1] = useState(false)
  const [showPopUp2,setShowPopUp2] = useState(false)
  const DoubtSubmitHandler = (e) => {
    e.preventDefault();
    setShowPopUp1(true)
  } 
  const yesHandler = () => {
    setShowPopUp1(false)
    setShowPopUp2(true)
  } 
  const onHideHandler = () => {
    setShowPopUp1(false)
    setShowPopUp2(false)
  }
  return (
    <div className="section">
    <ConfirmationModal
        title="Do you want to Submit the answer??"
        show={showPopUp1}
        onHide={onHideHandler}
        yesHandler={yesHandler}
        confirmTxt="yes"
      />
      <SuccessModal
        show={showPopUp2}
        onHide={onHideHandler}
        title="Answer Submitted Successfully!"
        btnTxt="Ok"
      />
      <h4>Doubts</h4>
      <Breadcrumb>
        <Breadcrumb.Item><Link to='/doubts'>Doubts</Link></Breadcrumb.Item>
        <Breadcrumb.Item active>Unanswered</Breadcrumb.Item>
        <Breadcrumb.Item active>Mohit Pratap(V2 - Hindi)</Breadcrumb.Item>
      </Breadcrumb>
      <form onSubmit={DoubtSubmitHandler}>
      <Graybg>
        <Card>
          <Row>
            <Col>
              <h5>
                <strong>MOHIT PRATAP</strong> (V2 - Hindi)
              </h5>
            </Col>
            <Col className="text-end">
              Posted at : <b>2 hours ago</b>{" "}
            </Col>
          </Row>
          <p className={classes["doubt-topic"]}>Solids, gases and molecules</p>
          <p className={classes["doubt"]}><span>Doubts: </span>Sir, please solve this problem for me. </p>
          <div className="text-center">
            <img
              className="rounded img-fluid"
              src="https://via.placeholder.com/800X300"
              alt="Doubt"
            />
          </div>
        </Card>
        <Card className={classes.cards}>
        <textarea className={classes.textarea} placeholder='Write your answer here' required></textarea>
        <i className={`bx bx-plus-circle ${classes.addIcon}`}></i>
        </Card>
      </Graybg>
      <div className='text-center'>
      <SecBTN type='submit' className={classes['submit-btn']}>Submit</SecBTN>
      </div>
      </form>
    </div>
  );
}

export default Unanswered
